import { takeLatest, takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services"
import config from '../config/config.json';

function* getLogin(actions) {

    try {
        const headers = {
            'Content-Type': "application/json"
        };

        if (actions.form.visitorId) {
            headers['visitor'] = actions.form.visitorId; // Agrega visitorId al header
        }

        const formToSend = { ...actions.form };
        delete formToSend.visitorId; // Elimina visitorId de la copia del formulario

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(formToSend)
        }; 

        let url = config.credentials.url + '/token/'
        const data = yield call(apiCall, 'post', url, requestOptions)

        yield put({ type: "GET_LOGIN_RESPONSE", value: data })

    } catch (error) {
        yield put({ type: "GET_LOGIN_RESPONSE", value: error })
    }
}

function* getLoginReintegro(actions) {

    try {
        const headers = {
            'Content-Type': "application/json"
        };

        const requestOptions = {
            headers: headers,
        }; 

        let url =  config.credentials.url + '/refund_data/?voucher_id='+actions.form.voucherId + '&document=' + actions.form.documento
    
        const data = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "GET_LOGIN_REINTEGRO_RESPONSE", value: data })

    } catch (error) {
        yield put({ type: "GET_LOGIN_REINTEGRO_RESPONSE", value: error })
    }
}

function* getLogout(actions) {
    // TO-DO: Enviar actions.access al backend para eliminar/deshabilitar token en la BD ya que no será mas valido.
    put({ type: "GET_LOGOUT" })
}

function* getLogoutReintegro(actions) {
    // TO-DO: Enviar actions.access al backend para eliminar/deshabilitar token en la BD ya que no será mas valido.
    put({ type: "GET_LOGOUT_REINTEGRO" })
}

/*
* Para usuarios logeado que quieren modificar su contraseña
*/
function* reset(actions) {

    try {

        const headers = {
            'Content-Type': "application/json",
        };
        const requestOptions = {
            headers: headers, 
            body: JSON.stringify(actions.data) // email
        };

        const response = yield call(apiCall, 'POST',config.credentials.url+'/password_reset/', requestOptions);

        yield put({ type: "PASSWORD_RESET_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "PASSWORD_RESET_RESPONSE", value: error })
    }
}

/*
* Envio de nueva contraseña.
*/
function* confirm(actions) {
    try {

        const headers = {
            'Content-Type': "application/json",
        };
        const requestOptions = {
            headers: headers, 
            body: JSON.stringify(actions.data) // token y nueva contraseña.
        };

        const response = yield call(apiCall, 'POST',config.credentials.url+'/password_reset/confirm/', requestOptions);

        yield put({ type: "PASSWORD_CONFIRM_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "PASSWORD_CONFIRM_RESPONSE", value: error })
    }
}

function* change(actions) {
    try {

        const { password, newPassword, passwordConfirm } = actions.data;

        const transformedData = {
            old_password: password,
            new_password: newPassword,
        };

        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers, 
            body: JSON.stringify(transformedData)
        };
        const response = yield call(apiCall, 'PUT',config.credentials.url+'/change_password/', requestOptions);

        yield put({ type: "PASSWORD_CHANGE_RESPONSE", value: response })

    } catch (error) {
        yield put({ type: "PASSWORD_CHANGE_RESPONSE", value: error })
    }
}

function* userModules(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        let url = (actions.query === null) ? config.credentials.url + '/profile/' : config.credentials.url + '/profile/' + actions.query

        const response = yield call(apiCall, 'get', url, requestOptions);

        if (response.id == undefined || response.id == null) {
            response["invalidToken"] = "Hubo un error";
        }

        switch (actions.queryType) {
            case "VIEW":
                yield put({ type: "USER_MODULE_RESPONSE", value: response })
                break;
            case "LOGIN":
                yield put({ type: "USER_MODULE_RESPONSE", value: response, access: actions.access })
                break;
            default:
                break;
        }
    } catch (error) {
        yield put({ type: "USER_MODULE_RESPONSE", value: error })
    }
}

function* authenticate(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
        };
        const requestOptions = {
            headers: headers, 
            body: JSON.stringify(actions.data) // email
        };

        const response = yield call(apiCall, 'POST',config.credentials.url+'/2fa_validation/', requestOptions);

        yield put({ type: "AUTHENTICATE_TOKEN_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "AUTHENTICATE_TOKEN_RESPONSE", value: error })
    }
}

export function* login() {
    yield takeEvery("GET_LOGIN", getLogin)
}

export function* logout() {
    yield takeEvery("GET_LOGOUT", getLogout)
}

export function* logoutReintegro() {
    yield takeEvery("GET_LOGOUT_REINTEGRO", getLogoutReintegro)
}

export function* resetPassword() {
    yield takeEvery("RESET_PASSWORD", reset)
}
export function* confirmPassword() {
    yield takeEvery("CONFIRM_PASSWORD", confirm)
}

export function* loginReintegro() {
    yield takeEvery("GET_LOGIN_REINTEGRO", getLoginReintegro)
}

export function* changePassword() {
    yield takeEvery("CHANGE_PASSWORD", change)
}

export function* getUserModules() {
    yield takeEvery("GET_USER_MODULES", userModules)
}

export function* authenticateToken() {
    yield takeEvery("AUTHENTICATE_TOKEN", authenticate)
}